import { useNavigate } from "react-router-dom"
import { useInView } from "react-intersection-observer"
import type { GalleryListResponse } from "@/service/api/gallery"
import { useAuth } from "@/shared/provider/AuthProvider"
import { useAlertDialog } from "@/shared/context/AlertDialogContext"

interface Props {
  galleryListData?: GalleryListResponse
}

const GalleryGridThree = ({ galleryListData }: Props) => {
  const navigate = useNavigate()
  const { showAlert, closeAlert } = useAlertDialog()
  const { userInfo } = useAuth()
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  const handleNavigate = (id: number) => {
    if (userInfo) {
      navigate(`gallery/${id}`, {
        state: { galleryList: galleryListData?.content },
      })
    } else {
      showAlert({
        logo: false,
        title: "Would you like to log in?",
        actionText: "Log in",
        cancelText: "Cancel",
        onConfirm: () => navigate("/login"),
        onCancel: () => closeAlert(),
      })
    }
  }

  return (
    <div className="px-4 grid grid-flow-col grid-rows-2 gap-0.5 h-[204px]">
      {galleryListData?.content.map((item, idx) => {
        const baseClass = "overflow-hidden"

        if (idx === 0) {
          return (
            <button
              onClick={() => handleNavigate(item.id)}
              key={`${item.id}-${idx}`}
              className={`col-span-2 row-span-2 rounded-l-xl ${baseClass}`}
              ref={ref}
            >
              {inView && (
                <img
                  src={item.imageUrl}
                  alt="Image"
                  className="object-cover w-full h-full"
                />
              )}
            </button>
          )
        }

        if (idx === 1) {
          return (
            <button
              onClick={() => handleNavigate(item.id)}
              key={`${item.id}-${idx}`}
              className={`col-span-1 rounded-tr-xl ${baseClass}`}
              ref={ref}
            >
              {inView && (
                <img
                  src={item.imageUrl}
                  alt="Image"
                  className="object-cover w-full h-full"
                />
              )}
            </button>
          )
        }

        if (idx === 2) {
          return (
            <button
              onClick={() => handleNavigate(item.id)}
              key={`${item.id}-${idx}`}
              className={`col-span-1 rounded-br-xl ${baseClass}`}
              ref={ref}
            >
              {inView && (
                <img
                  src={item.imageUrl}
                  alt="Image"
                  className="object-cover w-full h-full"
                />
              )}
            </button>
          )
        }

        return null
      })}
    </div>
  )
}

export default GalleryGridThree
